import { css } from 'goober';
import { isArray, isEmpty, isFunction, isString } from 'mc-ui-utils';
import React, { memo, useCallback, useEffect, useRef, useState, } from 'react';
import constants from '../../constants';
import { fromUTF8ArrayToString } from '../../utils/common';
import { getWebPeekHTML } from '../../utils/khazaddumbridge';
import { addListeners, removeListeners } from '../../utils/slider';
import { setUpWebpeekBridges, setWebpeekBaseUrl, } from '../../utils/webpeekhelper';
const Box = css `
  width: 100%;
  height: 100%;
  border-width: 0;
`;
const Webpeek = ({ glanceId, webPeek, webpeekOnLoadCb, isActive, slideshowPaused, backgroundImage, isHomeVisible, informStateUpdatedOnInvisible, isCurrentGlance, }) => {
    const [webpeekContent, setWebpeekContent] = useState(null); // webpeek html content
    const frame = useRef();
    const isMounted = useRef(false);
    const webpeekUrl = webPeek.url;
    useEffect(() => {
        var _a, _b, _c;
        const webpeekFrame = (_c = (_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.body;
        if (!isEmpty(glanceId)) {
            window.Gondolin.renderWebpeek = (arg) => {
                const array = isString(arg) ? JSON.parse(arg) : arg;
                if (isArray(array)) {
                    const html = fromUTF8ArrayToString(array);
                    if (!isEmpty(html) && html !== 'null') {
                        setWebpeekContent(html);
                        webpeekOnLoadCb(glanceId, true);
                        return;
                    }
                }
                webpeekOnLoadCb(glanceId, false);
            };
            getWebPeekHTML(glanceId, 'window.Gondolin.renderWebpeek');
        }
        return () => {
            if (webpeekFrame) {
                removeListeners(webpeekFrame, {
                    onSwipeStart,
                    onSwipeMove,
                    onSwipeEnd,
                });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceId]);
    useEffect(() => {
        /**
         * we are not adding isCurrentGlance as a dependency as we want this useEffect to be executed
         * when isHomeVisible is changed from true to false.
         * we do not want this to run whenever isCurrentGlance changes.
         */
        if (!isHomeVisible && isCurrentGlance) {
            console.log('inside webpeek');
            informStateUpdatedOnInvisible();
        }
    }, [isHomeVisible]);
    useEffect(() => {
        var _a;
        if (!isEmpty(webpeekContent) && !isEmpty((_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow)) {
            setUpWebpeekBridges(frame.current, glanceId, webpeekUrl, backgroundImage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webpeekContent]);
    const proxyTouchEvent = useCallback((eventType, event) => {
        if (!isEmpty(event.touches)) {
            const target = document.getElementById(constants.MAIN_BACKGROUND_ID);
            const touchEvent = new TouchEvent(eventType, {
                touches: event.touches,
            });
            target.dispatchEvent(touchEvent);
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (isActive &&
            slideshowPaused &&
            !isHomeVisible &&
            isFunction((_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.outOfFocus)) {
            frame.current.contentWindow.outOfFocus();
        }
        if (isActive &&
            !slideshowPaused &&
            isHomeVisible &&
            isFunction((_d = (_c = frame.current) === null || _c === void 0 ? void 0 : _c.contentWindow) === null || _d === void 0 ? void 0 : _d.onFocus)) {
            frame.current.contentWindow.onFocus();
        }
    }, [slideshowPaused, isActive, isHomeVisible]);
    useEffect(() => {
        var _a, _b;
        if (isMounted.current &&
            !isActive &&
            isFunction((_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.outOfFocus)) {
            frame.current.contentWindow.outOfFocus();
        }
    }, [isActive, webpeekUrl, glanceId, backgroundImage]);
    const onSwipeStart = useCallback((event) => {
        proxyTouchEvent('touchstart', event);
    }, [proxyTouchEvent]);
    const onSwipeMove = useCallback((event) => {
        proxyTouchEvent('touchmove', event);
    }, [proxyTouchEvent]);
    const onSwipeEnd = useCallback((event) => {
        proxyTouchEvent('touchend', event);
    }, [proxyTouchEvent]);
    const onLoadCallback = useCallback(() => {
        const webpeekFrame = frame.current.contentWindow;
        isMounted.current = true;
        addListeners(webpeekFrame, { onSwipeStart, onSwipeMove, onSwipeEnd });
        if (isFunction(frame.current.contentWindow.onFocus) && isActive) {
            frame.current.contentWindow.onFocus();
        }
        setUpWebpeekBridges(frame.current, glanceId, webpeekUrl, backgroundImage);
    }, [onSwipeEnd, onSwipeMove, onSwipeStart, isActive]);
    let html = constants.EMPTY_HTML;
    if (isEmpty(webpeekContent)) {
        return null;
    }
    if (!isEmpty(webpeekContent)) {
        html = setWebpeekBaseUrl(webPeek.url, webpeekContent);
    }
    return (React.createElement("iframe", { className: `${Box}${isActive ? ' active' : ''}`, ref: frame, src: webPeek.url, onLoad: onLoadCallback, srcDoc: html }));
};
export default memo(Webpeek);
//# sourceMappingURL=index.js.map